export default {
  STATE_LICENSE_DELETED_SUCCESS: "State license deleted.",
  STATE_LICENSE_CREATED_SUCCESS: "State license created.",
};
